module.exports = __webpack_public_path__ + "img/loading.885e7dfc.png";